import React from 'react'
import Alert from '../../components/Alert/Alert'
import PropTypes from 'prop-types'

const PartySelectorAlert = ({ validation, labels, handleClick }) => {
  for (const key in validation) {
    if (!validation[key]) {
      return (
        <Alert
          data-element={key}
          key={key}
          {...key === 'minGroupSize' && {
            buttonLabel: labels.bookAFlightButtonLabel,
            buttonAction: handleClick,
          }}
        >
          {labels[`${key}Message`]}
        </Alert>
      )
    }
  }
  return null
}

PartySelectorAlert.propTypes = {
  handleClick: PropTypes.func,
  validation: PropTypes.object,
  labels: PropTypes.object,
}

export default PartySelectorAlert
